module.exports = __webpack_public_path__ + "img/dash.4ec5a661.png";